import logo from "./images/logo.png";
import err from "./images/err.jpg";
import err404 from "./images/404.jpg";
import defaults from "./images/defaults.png";
import vedio from "./images/vedio.png";
import play from "./images/play.png";
import obi from "./images/obi.png";
import payment from "./images/payment.png";
import obi2 from "./images/obi2.png";
import image01 from "./images/image01.png";
import image02 from "./images/image02.png";
import image03 from "./images/image03.png";
import image04 from "./images/image04.png";
import twitter from "./images/twitter.png";
import youtube from "./images/youtube.png";
import facebook from "./images/facebook.png";
import linkedin from "./images/linkedin.png";
import annoucement from "./images/annoucement.png";
import instagram from "./images/instagram.png";
import davido from "./images/davido.png";
import fb from "./images/fb.png";
import live from "./images/live.jpg";
import dp from "./images/dp.png";
import gmail from "./images/gmail.png";
import placeholder from "./images/placeholder.png";
import adeleke from "./images/adeleke.png";
import bitcoin from "./images/bitcoin.png";
//eslint-disable-next-line
export default {
  image04,
  dp,
  adeleke,
  defaults,
  bitcoin,
  gmail,
  payment,
  obi2,
  placeholder,
  logo,
  live,
  fb,
  err404,
  err,
  davido,
  facebook,
  instagram,
  twitter,
  youtube,
  linkedin,
  vedio,
  annoucement,
  image01,
  image02,
  image03,
  play,
  obi,
};
